import { useEffect, useState } from 'react';
import { MessageSquarePlus } from 'lucide-react';
import { FeedbackDialog } from '@/components/feedback/FeedbackDialog';
import { MicroSurveyHost } from '@/components/feedback/MicroSurvey';
import { onOpenFeedback, type FeedbackPrefill } from '@/lib/feedbackBus';

/**
 * Botão fixo "Feedback" montado em #floating-actions em todos os layouts.
 * Também atende pedidos de abertura vindos de outras telas (ex.: "Reportar" em
 * toasts de erro) e hospeda a micro-pesquisa pós-momentos-chave.
 */
export function FeedbackButton() {
  const [isOpen, setIsOpen] = useState(false);
  const [prefill, setPrefill] = useState<FeedbackPrefill>({});

  useEffect(
    () =>
      onOpenFeedback((next) => {
        setPrefill(next);
        setIsOpen(true);
      }),
    []
  );

  return (
    <>
      <button
        type="button"
        onClick={() => {
          setPrefill({});
          setIsOpen(true);
        }}
        className="group inline-flex items-center gap-2 rounded-full border border-line bg-elevated px-3 py-2.5 text-sm font-semibold text-ink shadow-elevation-3 transition-all hover:-translate-y-0.5 hover:border-brand-400 hover:text-brand-700 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-500 lg:px-4 dark:hover:text-brand-300"
        aria-haspopup="dialog"
        aria-label="Feedback: reportar um problema, sugerir uma melhoria ou elogiar"
        title="Reportar um problema, sugerir uma melhoria ou elogiar"
      >
        <MessageSquarePlus className="h-4 w-4 transition-transform group-hover:-rotate-6" aria-hidden="true" />
        <span aria-hidden="true">Feedback</span>
      </button>

      <FeedbackDialog isOpen={isOpen} onClose={() => setIsOpen(false)} prefill={prefill} />
      <MicroSurveyHost />
    </>
  );
}
